import React, { useState } from "react";
import Check from "../../../assets/images/fi_check.svg";
import Arrow from "../../../assets/images/Arrow.svg";

function ResponsiveToursCard({
  icon,
  title,
  gradientBackground,
  conicBackground,
  isExpanded,
  handleGroupClick,
}) {
  return (
    <div>
      {/* Group Button */}
      <button
        onClick={handleGroupClick}
        className={`leap-flex leap-relative leap-items-center leap-justify-between  leap-ml-2 leap-px-4 leap-py-3 leap-rounded-xl leap-border leap-border-solid leap-border-[#99999999] ${
          isExpanded
            ? "leap-bg-[#85869f] leap-border-[#ffffff99]"
            : "leap-bg-[#373861] leap-border-[#99999999]"
        }`}
      >
        <div
          className="leap-absolute leap-left-0 -leap-translate-x-[50%]  leap-rounded-full "
          style={{
            background: "linear-gradient(180deg, #8547F6 0%, #BC98FF 100%)",
          }}
        >
          <img
            src={icon}
            alt="Icon"
            className=" leap-w-8 leap-h-8 leap-p-[4px] "
            loading="lazy"
          />
        </div>
        <div className=" leap-relative leap-flex leap-items-center leap-gap-2 leap-h-10  leap-w-auto leap-min-w-32 leap-justify-center">
          <span className="leap-text-white leap-px-2 leap-font-bold leap-uppercase leap-text-[10px] leap-text-center">
            {title}
          </span>
        </div>
      </button>
    </div>
  );
}

export default ResponsiveToursCard;
